import { render } from "./ScreenCockpit.vue?vue&type=template&id=d11e29ba"
import script from "./ScreenCockpit.vue?vue&type=script&lang=js"
export * from "./ScreenCockpit.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bruno/Documents/Codex/bam4-share-link-work/bam4-master/client/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.69.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__